import { MONTHLY_AMOUNT_USD } from "./billing";

export const STRIPE_MONTHLY_PRICE_ID =
  import.meta.env.VITE_STRIPE_MONTHLY_PRICE_ID || "";

export const PRICES = {
  monthly: {
    id: STRIPE_MONTHLY_PRICE_ID,
    amount: MONTHLY_AMOUNT_USD,
    label: "$5/mo",
  },
} as const;
